import { FilterChip } from '@marqvision/shared';
import { MarqCommonEnumsAiClientTagEnum } from '~/swagger/data-contracts';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useGetFilterParams, usePathParams } from './@hooks';
import { TAG_FILTER_LABEL } from './@constants';

export const TopResultsFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { top_result_filter: topResults } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();
  const handleChange = () => {
    const newState = !topResults;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: 'top results',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }
    setParams({
      top_results: !topResults,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!topResults}
      label={TAG_FILTER_LABEL[MarqCommonEnumsAiClientTagEnum.TopResult]}
      onClick={handleChange}
    />
  );
};
